var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap is_complete"},[_c('div',{staticClass:"tbl_inner"},[_c('div',{staticClass:"tbl_row",class:{parents: _vm.$isIamschoolParent, student: _vm.$isIamschoolStudent}},[_c('div',{staticClass:"tbl_cell complete_txt_area"},[_c('p',{staticClass:"complete_txt"},[_vm._v(_vm._s(_vm.$t(_vm.payload.message)))])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }